import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  showAuthModal: false,
  ws: null,
  layouts: {
    trackingLayout: {
      a: { top: 20, left: 80, title: "Hello from test" },
    },
    trackingLayoutMinimised: {}, // Add two keywords when you want to have different layout
  },
  readMoreValue: 2,
  source_ids: null,
  flash_screen: false,
  variableDatas: null,
  lastVisitedApp: [],
  globalDockAlign: "split-down",
  selectedRange: {
    startDate: moment().subtract(24, "hours").toISOString(),
    endDate: moment().toISOString(),
  },
  currentTab: "Map",
  displayConfigId: null,
  globalMapProvider: null,
  globalMapKey: null,
  globalResetCount: 0,
  liveTrackData: [],
  globalLiveLastDataTime: 10,
  globalCustomJson: null,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    toggleAuthModal: (state) => {
      state.showAuthModal = !state.showAuthModal;
    },
    setWebSocket: (state, action) => {
      state.ws = action.payload;
    },
    setLayout: (state, action) => {
      const { layoutName, value } = action.payload;
      state.layouts[layoutName] = value;
    },
    addToLayout: (state, action) => {
      const { key, layoutName } = action.payload;
      let minimisedComponents = `${layoutName}Minimised`;

      if (state.layouts[minimisedComponents][key]) {
        state.layouts[layoutName][key] = state.layouts[minimisedComponents][key];
        delete state.layouts[minimisedComponents][key];
      } else {
        state.layouts[layoutName][key] = { top: 20, left: 80, ...action.payload };
      }
    },
    minimise: (state, action) => {
      const { key, layoutName } = action.payload;
      let minimisedComponents = `${layoutName}Minimised`;
      state.layouts[minimisedComponents][key] = state.layouts[layoutName][key];
      delete state.layouts[layoutName][key];
    },
    toggleNotificationBar: (state, action) => {
      state.readMoreValue = action.payload;
    },
    setSourceIdsGlobal: (state, action) => {
      state.source_ids = action.payload;
    },
    setFlashScreen: (state, action) => {
      state.flash_screen = action.payload;
    },
    setVariableDatas: (state, action) => {
      state.variableDatas = action.payload;
    },
    setlastVisitedApp: (state, action) => {
      state.lastVisitedApp.push(action.payload);
    },
    setGlobalDockAlign: (state, action) => {
      state.globalDockAlign = action.payload;
    },
    setSelectedRange: (state, action) => {
      const { startDate, endDate } = action.payload;
      state.selectedRange.startDate = startDate;
      state.selectedRange.endDate = endDate;
    },
    setCurrentTabGlobal: (state, action) => {
      state.currentTab = action.payload;
    },
    setDisplayConfigId: (state, action) => {
      state.displayConfigId = action.payload;
    },
    setGlobalMapProvider: (state, action) => {
      state.globalMapProvider = action.payload;
    },
    setGlobalMapKey: (state, action) => {
      state.globalMapKey = action.payload;
    },
    setGlobalResetCount: (state, action) => {
      state.globalResetCount = action.payload;
    },
    setLiveTrackData: (state, action) => {
      state.liveTrackData = action.payload;
    },
    setGlobalLiveLastDataTime: (state, action) => {
      state.globalLiveLastDataTime = action.payload;
    },
    setGlobalCustomJson: (state, action) => {
      state.globalCustomJson = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  toggleAuthModal,
  setWebSocket,
  setLayout,
  addToLayout,
  removeFromLayout,
  minimise,
  setSourceIdsGlobal,
  setFlashScreen,
  setVariableDatas,
  setlastVisitedApp,
  setGlobalDockAlign,
  setSelectedRange,
  setCurrentTabGlobal,
  setDisplayConfigId,
  setGlobalMapProvider,
  setGlobalMapKey,
  setGlobalResetCount,
  setLiveTrackData,
  setGlobalLiveLastDataTime,
  setGlobalCustomJson,
} = commonSlice.actions;

export const commonReducer = commonSlice.reducer;
